// Copyright (c) Alkacon Software GmbH & Co. KG (http://www.alkacon.com)
//
// All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.

"use strict";

var fv_iel = null;
var fv_hel = null;

function setFvSize() {
    if (window.outerHeight != window.prevOuterHeight) {
        window.prevOuterHeight = window.outerHeight;
        fv_iel.style.setProperty('--fvwh', window.innerHeight + 'px');
        if (window.showNavifation && fv_hel != null) {
            fv_iel.style.setProperty('--fvhh', fv_hel.offsetHeight + 'px');
        }
    }
}

function initFv(jQ, DEBUG) {
    if (DEBUG) console.info("initFv()");
    fv_iel = document.querySelector('.full-visual > .full-visual-image');
    if (fv_iel != null) {
        fv_hel = document.querySelector('header');
        document.querySelector('#mercury-page').classList.add('full-visual-page');
        window.prevOuterHeight = 0;
        window.showNavifation = document.querySelector('.full-visual.show-navigation') != null;
        setFvSize();
        window.addEventListener('resize', function() {
            setFvSize();
        });
        window.addEventListener('orientationchange', function() {
            setTimeout(function() {
                window.prevOuterHeight = 0;
                setFvSize();
            }, 250);
        });
        window.addEventListener('scroll', function() {
            var sY = window.scrollY;
            var wH = window.innerHeight / 2;
            if (sY < wH) {
                fv_iel.style.setProperty('--fvco', (wH - sY) / wH);
                fv_iel.style.setProperty('--fvct', Math.round(sY / 4) + 'px');
            } else {
                fv_iel.style.setProperty('--fvco', 0);
                fv_iel.style.setProperty('--fvct', Math.round(wH / 4) + 'px');
            }
        });
        window.dispatchEvent(new Event('resize'));
    }
}

mercury.ready(initFv);
